import { ClientContact } from "@jugl-web/rest-api";
import {
  FormGroup,
  Avatar,
  SelectTrigger,
  ResourcePickerPopover,
} from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import React from "react";
import { useContactListBox } from "@jugl-web/domain-resources/contacts/hooks/useContactListBox";

interface ContactPickerFieldProps {
  selectedContact?: ClientContact;
  onSelect: (contact: ClientContact) => void;
}

export const ContactPickerField: React.FC<ContactPickerFieldProps> = ({
  selectedContact,
  onSelect,
}) => {
  const { t } = useTranslations();
  const { entityId } = useEntitySelectedProvider();
  const { getListBoxProps, clearSearchQuery } = useContactListBox({
    entityId,
  });

  const listBoxProps = getListBoxProps({
    defaultSelectedIds: selectedContact ? [selectedContact.id] : undefined,
  });

  const label = selectedContact
    ? selectedContact.name || ""
    : t({
        id: "common.select",
        defaultMessage: "Select",
      });

  return (
    <FormGroup
      label={t({
        id: "client-support-page.link-to-existing-customer",
        defaultMessage: "Link to Existing Customer",
      })}
      labelPosition="border-overlap"
      classNames={{
        labelBackgroundClassName: "!top-0 !mb-0 -translate-y-1/2",
      }}
    >
      <ResourcePickerPopover
        placement="bottom-start"
        className="w-[300px]"
        isHeightFixed
        onSelect={({ item, onClose }) => {
          onSelect(item.value);
          onClose();
        }}
        onOpenStateChange={(isOpen) => {
          if (!isOpen) {
            clearSearchQuery();
          }
        }}
        renderTrigger={({ Trigger, triggerRef, isOpen }) => (
          <Trigger ref={triggerRef} as="div">
            <SelectTrigger
              isOpen={isOpen}
              hasValue={Boolean(selectedContact)}
              label={
                selectedContact ? (
                  <div className="flex min-w-0 items-center gap-2.5">
                    <Avatar size="sm" username={label} className="shrink-0" />
                    <span className="truncate">{label}</span>
                  </div>
                ) : (
                  label
                )
              }
            />
          </Trigger>
        )}
        {...listBoxProps}
      />
    </FormGroup>
  );
};
